let timerId: ReturnType<typeof setTimeout> | undefined;
let timeout = 0;

export const searchTimeoutQueryHook = (query: any, search: any) => {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), 400);
};
